import { Link, useLocation } from '@remix-run/react'

import { ChevronLeftIcon } from '@heroicons/react/16/solid'
import RedIcon from '~/components/RedIcon'

export default function BookingInfo() {
  const location = useLocation()
  const search = new URLSearchParams(location.search)
  const back = location.pathname.replace(
    '/info',
    search.has('back') ? `/${search.get('back')}` : '',
  )

  return (
    <section className="text-neutral-800 prose-h2:text-base prose-h2:font-bold prose-h2:my-0 leading-6">
      <Link
        to={back}
        className="font-semibold flex gap-1 text-sm no-underline mb-6"
      >
        <ChevronLeftIcon className="w-6 inline" />{' '}
        {search.has('back')
          ? 'Back to booking instructions'
          : 'Back to overview'}
      </Link>

      <h1 className="text-lg font-semibold mb-1">
        Important notes for your trip
      </h1>
      <p className="text-sm text-neutral-600 mt-0">
        Things you should be aware of before booking.
      </p>
      <div className="divide-y-2 divide-y-neutral-400 space-y-8">
        <div className="pt-8">
          <RedIcon iconsvg="calendar" small className="mb-3" />
          <h2>Book as soon as possible</h2>
          <p>
            Award availability is subject to change at any time. To ensure you
            get the flights you want, we recommend booking as soon as possible.
          </p>
        </div>
        <div className="pt-8">
          <RedIcon iconsvg="dollar" small className="mb-3" />
          <h2>All amounts in Australian Dollars (AUD)</h2>
          <p>
            All tax amounts quoted in this document are in Australian Dollars
            (AUD) unless specified and are subject to change.
          </p>
        </div>
        <div className="pt-8">
          <RedIcon iconsvg="ticket" small className="mb-3" />
          <h2>Ensure your flight is “ticketed”</h2>
          <p>
            There is a difference between a flight "reservation" and the flight
            "ticket" being issued (known as "ticketing"). Sometimes ticketing
            follows immediately or overnight after a booking was made, but
            sometimes it can take days or even weeks, if the flight is some way
            into the future and your booking has been flagged for manual
            processing. It is your responsibility to ensure your flights are
            ticketed. You may need to contact the airline if you have not
            received a ticket number within 24 hours of booking, as you may lose
            your flight/s if the booking is not ticketed within a few days.
          </p>
        </div>
        <div className="pt-8">
          <RedIcon iconsvg="shield" small className="mb-3" />
          <h2>Take up travel insurance</h2>
          <p>
            We highly recommend that you purchase appropriate travel insurance
            for your trip.
          </p>
        </div>
        <div className="pt-8">
          <RedIcon iconsvg="plane" small className="mb-3" />
          <h2>International Travel Requirements</h2>
          <p>
            It is your responsibility to ensure you have the necessary
            documentation (including a valid passport and visas, if required)
            for your destination.
          </p>
          <p>
            Please familiarise yourself with the entry requirements for your
            destination/s, and any transit requirements that may apply when
            transiting via intermediate airports. These requirements could
            change between now and your departure date. 
          </p>
          <p>
            Please confirm the latest requirements shortly before commencing
            your journey.
          </p>
        </div>
        <div className="pt-8">
          <h2>Disclaimer</h2>
          <p>
            Our service is to provide information about award flight
            availability and booking options, using availability at the time
            this report was prepared. Bookings made because of our advice are
            entirely at the risk and cost of the newsletter reader. It is the
            newsletter reader's responsibility to ensure that their booking made
            online or over the phone becomes "ticketed" before the flight. Point
            Hacks Travel is not responsible for booking outcomes, flight
            schedule changes, delays, cancellations, or other airline or
            government actions.
          </p>
        </div>
      </div>
    </section>
  )
}
